"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSessionTrackingInfo = exports.requestCameraAccess = exports.updatePassword = exports.shareFile = exports.refreshTokenV2 = exports.refreshToken = exports.openBrowserLink = exports.listenOtp = exports.invalidateCache = exports.initOtp = exports.goBack = exports.getDeviceSessionData = exports.getUserName = exports.getLanguage = exports.getGeolocation = exports.getDeviceInfo = exports.getContact = exports.getAccessToken = exports.getAccountInfo = exports.finishProcess = exports.finishOtp = exports.downloadFile = exports.changeAntiFraudContext = void 0;
const init_1 = require("./init");
const changeAntiFraudContext = (data) => {
    return init_1.mobileConnector.changeAntiFraudContext(data);
};
exports.changeAntiFraudContext = changeAntiFraudContext;
const downloadFile = (data) => {
    return init_1.mobileConnector.downloadFile(data);
};
exports.downloadFile = downloadFile;
const finishOtp = () => {
    return init_1.mobileConnector.finishOtp();
};
exports.finishOtp = finishOtp;
const finishProcess = (data) => {
    return init_1.mobileConnector.finishProcess(data);
};
exports.finishProcess = finishProcess;
const getAccountInfo = () => {
    return init_1.mobileConnector.getAccountInfo();
};
exports.getAccountInfo = getAccountInfo;
const getAccessToken = () => {
    return init_1.mobileConnector.getAccessToken();
};
exports.getAccessToken = getAccessToken;
const getContact = () => {
    return init_1.mobileConnector.getContact();
};
exports.getContact = getContact;
const getDeviceInfo = () => {
    return init_1.mobileConnector.getDeviceInfo();
};
exports.getDeviceInfo = getDeviceInfo;
const getGeolocation = () => {
    return init_1.mobileConnector.getGeolocation();
};
exports.getGeolocation = getGeolocation;
const getLanguage = () => {
    return init_1.mobileConnector.getLanguage();
};
exports.getLanguage = getLanguage;
const getUserName = () => {
    return init_1.mobileConnector.getUserName();
};
exports.getUserName = getUserName;
const getDeviceSessionData = () => {
    return init_1.mobileConnector.getDeviceSessionData();
};
exports.getDeviceSessionData = getDeviceSessionData;
const goBack = () => {
    return init_1.mobileConnector.goBack();
};
exports.goBack = goBack;
const initOtp = () => {
    return init_1.mobileConnector.initOtp();
};
exports.initOtp = initOtp;
const invalidateCache = () => {
    return init_1.mobileConnector.invalidateCache();
};
exports.invalidateCache = invalidateCache;
const listenOtp = (callbackSuccess, callbackError) => {
    init_1.mobileConnector.listenOtp(callbackSuccess, callbackError);
};
exports.listenOtp = listenOtp;
const openBrowserLink = (data) => {
    return init_1.mobileConnector.openBrowserLink(data);
};
exports.openBrowserLink = openBrowserLink;
const refreshToken = () => {
    return init_1.mobileConnector.refreshToken();
};
exports.refreshToken = refreshToken;
const refreshTokenV2 = () => {
    return init_1.mobileConnector.refreshTokenV2();
};
exports.refreshTokenV2 = refreshTokenV2;
const shareFile = (data) => {
    return init_1.mobileConnector.shareFile(data);
};
exports.shareFile = shareFile;
const updatePassword = () => {
    return init_1.mobileConnector.updatePassword();
};
exports.updatePassword = updatePassword;
const requestCameraAccess = () => {
    return init_1.mobileConnector.requestCameraAccess();
};
exports.requestCameraAccess = requestCameraAccess;
const requestSessionTrackingInfo = () => {
    return init_1.mobileConnector.requestSessionTrackingInfo();
};
exports.requestSessionTrackingInfo = requestSessionTrackingInfo;
//# sourceMappingURL=mobileConnectorFn.js.map